import * as tslib_1 from "tslib";
import * as React from 'react';
import HeaderCharm from './HeaderCharm';
import strings from 'owa-strings/owa-common-strings';
import { FeedbackPane } from 'owa-header-pane';
import { observer } from 'mobx-react';
var FeedbackCharm = /** @class */ (function (_super) {
    tslib_1.__extends(FeedbackCharm, _super);
    function FeedbackCharm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FeedbackCharm.prototype.render = function () {
        return (React.createElement(HeaderCharm, { key: "feedbackEntry", icons: {
                iconName: "Emoji2" /* Emoji2 */,
                hoverIconName: "Emoji" /* Emoji */,
            }, title: strings.feedbackCharm_ariaLabel, ariaLabel: strings.feedbackCharm_ariaLabel, behavior: {
                paneComponent: FeedbackPane,
                charm: 0 /* FeedbackCharm */,
            } }));
    };
    FeedbackCharm = tslib_1.__decorate([
        observer
    ], FeedbackCharm);
    return FeedbackCharm;
}(React.Component));
export default FeedbackCharm;
//# sourceMappingURL=FeedbackCharm.js.map